import { render, staticRenderFns } from "./AccidentTypeEdit.vue?vue&type=template&id=6d82a307"
import script from "./AccidentTypeEdit.vue?vue&type=script&lang=js"
export * from "./AccidentTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports